const $ = document.querySelector.bind(document); // Team jQuery

const handleHamburgerClick = (e) => {
	const nav = $('.Exp-nav');
	const hamburger = $('.Exp-hamburger');
	const expClass = 'Exp-nav--expanded';

	if (nav.classList.contains(expClass)) {
		nav.classList.remove(expClass);
		hamburger.classList.remove('Exp-hamburger--close');
	} else {
		nav.classList.add(expClass);
		hamburger.classList.add('Exp-hamburger--close');
	}

	if (e) {
		e.preventDefault();
	}
};

export default handleHamburgerClick;
